<template>
  <div class="userConter" style="heigth:100%">
    <myTitle til="用户中心"></myTitle>
    <main>
      <template>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="基本信息" name="first">
            <Information v-if="activeName==='first'"></Information>
          </el-tab-pane>
          <el-tab-pane v-if="flag && !$independence" label="用户认证" name="information">
            <authenticationTabs v-if="activeName==='information'"></authenticationTabs>
          </el-tab-pane>
          <el-tab-pane v-if="!$privatization && !$independence" label="我的钱包" name="MyWallet" style="height:100%">
            <MyWallet v-if="activeName==='MyWallet'"> </MyWallet>
          </el-tab-pane>
          <el-tab-pane v-if="!$privatization && isFeedback" label="意见反馈" name="feedback">
            <Feedback v-if="activeName==='feedback'"> </Feedback>
          </el-tab-pane>

        </el-tabs>
      </template>
    </main>
    <messageBox v-if="mesBox" :isShow="mesBox" :tit="title" txt :mesShow="mesShow" :params="params" :imgSrc="imgSrc1"
      ifForm="1" @message="showMesBox" @messageIf="messageIf"></messageBox>
  </div>
</template>

<script>
import myTitle from "@/common/title.vue";
import messageBox from "@/common/messageBox.vue";
import Information from "@/common/information.vue";
import Feedback from "@/common/feedback.vue";
import authenticationTabs from "@/common/authentication/authenticationTabs.vue";
import MyWallet from "@/common/myWallet/myWallet.vue";

export default {
  name: "userConter",
  data () {
    return {
      activeName: 'first',
      mesShow: "22",
      title: "",
      mesBox: false,
      flag: true,
      isFeedback:true

    };
  },
  created () {
    if (process.env.VUE_APP_NAME==='shanghai') {
       this.isFeedback = false
    } 

    if (process.env.VUE_APP_NAME == "hospital") {

      this.flag = true //false
    } else {

      if (this.$privatization) {
        this.flag = false
      } else {
        this.flag = true
      }

    }
    //判断从哪里跳过来
    if (sessionStorage.getItem('activeName')) {
      this.activeName = sessionStorage.getItem('activeName')
    } else {
      this.activeName = this.$route.query.activeName
    }
  },
  beforeUpdate () {
    sessionStorage.setItem('activeName', this.activeName)
  },
  beforeDestroy () {
    sessionStorage.removeItem('activeName');
  },
  watch: {
    $route (to, from) {
      this.activeName = this.$route.query.activeName
    }
  },
  methods: {

    handleClick (tab, event) {
      if (tab.name == "information") {
      }
    },

  },
  components: {
    myTitle,
    messageBox,
    Information,
    Feedback,
    authenticationTabs,
    MyWallet,
  }
};
</script>
<style lang="less" scoped>
/deep/.el-tabs__nav-wrap::after {
  background: white;
}
.userConter {
  height: 100%;
}
main {
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 5px 16px 0px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  margin-top: 20px;
  padding: 20px;
  position: relative;
  // min-height: 723px;
  height: calc(100% - 84px);
}
.userImg {
  width: 450px;
  margin: 50px auto 80px;
  margin-bottom: 40px;
  ul {
    height: 130px;
    li {
      display: inline-block;
      text-align: left;
      p {
        font-size: 18px;
        color: #2579cf;
        margin: 40px 0 15px 0px;
        cursor: pointer;
        font-family: Microsoft YaHei;
        font-weight: 400;
      }
      span {
        font-size: 14px;
        color: #999999;
      }
    }
  }
  img {
    width: 130px;
    height: 130px;
    border-radius: 75px;
    // border: 1px solid #ccc;
  }
}
.el-input.is-disabled .el-input__inner {
  background-color: #fff !important;
  border-color: #e4e7ed;
  color: #c0c4cc;
}
.el-input {
  width: 90% !important;
}
.el-input__inner {
  width: 90% !important;
}
.form-item-info {
  width: 610px;
  margin: 0 auto;
  text-align: left;
  font-size: 14px;
}
.item-left {
  display: inline-block;
  vertical-align: middle;
  width: 320px;
}
.item-right {
  color: rgba(34, 34, 34, 1);
  cursor: pointer;
}
.item-list {
  overflow: hidden;
  line-height: 32px;
}
.item-block {
  // padding:10px;
  // height: 145px;
  margin-right: 10px;
  margin-bottom: 10px;
  padding: 0 17px;
  background: rgba(69, 69, 69, 1);
  color: #ffffff;
  font-size: 14px;
  border-radius: 6px;
  float: left;
}
.item-block-list {
  padding: 0 11px;
  background: rgba(153, 153, 153, 1);
}
.item-block:hover {
}
.cur {
  cursor: pointer;
}
.scoped-icon {
  padding-right: 18px;
  vertical-align: middle;
  width: 27px;
}
.scoped-close {
  cursor: pointer;
  padding-left: 5px;
}
.label-box {
  font-size: 16px;
}
/deep/.el-tabs {
  height: 100%;
  overflow-y: auto;
  .el-tabs__content {
    height: calc(100% - 60px);
    overflow: auto;
  }
  .is-active {
    color: #11a4ff;
  }
  .el-tabs__item {
    font-size: 16px;
    font-weight: bold;
  }
  .el-tabs__active-bar {
    background-color: #11a4ff;
  }
}
</style>